import { createGetAllApi } from "@api/util/createGetAllApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam } from "./path";
import type { IAvailablePlanYearsResponse } from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IAvailablePlanYearsResponse>>,
  IPathBaseParam,
  IPaginationParams
>("availablePlanYears");

export const availablePlanYears = {
  ...getAllApis,
};
